export const CREATE_GROUP = 'group/createGroup';
export const GET_GROUPS_LIST = 'group/getGroupsList';
export const GET_GROUP_MEMBERS = 'group/getGroupMembers';
export const UPDATE_GROUP = 'group/updateGroup';
export const DELETE_GROUP = 'group/deleteGroup';
export const DELETE_GROUP_MEMBER = 'group/deleteGroupMember';
export const ADD_GROUP_MEMBERS = 'group/addGroupMembers';
export const SET_DEFAULT_GROUP_MEMBER = 'group/setDefaultGroupMember';
export const RECOVER_GROUP = 'group/recoverGroup';
